import { sharedParamsConfig } from '@oneToOne/shared/params'

import type { ParamsType } from '@core/params'
import { mergeConfigs } from '@core/params'
import { pipParamsConfig } from '@core/pictureInPicture/config'
import type { PIPParams } from '@core/pictureInPicture/types'

export const liveHelperPlacements = ['BOTTOM_LEFT', 'BOTTOM_RIGHT'] as const

const liveHelperConfigs = {
  stringParams: ['chat_channel_id', 'activation_question'],
  boolParams: [
    'silent_mode',
    'bypass_sa_availability',
    'dismiss_after_conversation_ended',
    'hide_outside_office_hour',
    'bypass_qualify_visitors',
    'bypass_widget_availability_hidden',
    'close_widget',
  ],
  numberParams: ['idle_minimized_z_index'],
  enumParams: {
    live_helper_placement: liveHelperPlacements,
    initial_actions: ['chat_only'],
  },
} as const
// Unable to use `satisfies`. Need storybook 7+ to not break chromatic CI
// } as const satisfies ParamsConfig

export const configs = mergeConfigs(
  sharedParamsConfig,
  pipParamsConfig,
  liveHelperConfigs,
)

export type LiveHelperParams = ParamsType<typeof configs> & PIPParams
